import React from "react";
import { Formik } from "formik";
import { AccordionContent } from "../../../components/ui/accordion";
import { Label } from "../../../components/ui/label";
import DropDownList from "../../../components/DropDownList";
import { Button } from "../../../components/ui/button";
import { Icons } from "../../../components/icons";
import FormError from "../../../components/FormError";
import fetchData from "../../../utils/api";
import { TableReservationMethodFormValidation } from "./Validation";
import { useTranslation } from "react-i18next";
import { Config } from "../../../utils/config";

export default function TableReservationCart({
  cartList,
  authToken,
  id,
  restaurantDetail,
  handleCartList,
  handleAccordionClick,
}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [persons, setPersons] = React.useState<any>([]);
  const [tablePreferenceList, setTablePreferenceList] = React.useState<any>([]);

  const handleTableReservationInfo = async () => {
    try {
      const res = await fetchData({
        url: "cart/table-reservation-info",
        method: "POST",
        token: authToken,
      });
      if (res.status_code === 200) {
        setPersons(res.data?.table_reservation_person_list);
        setTablePreferenceList(
          res.data?.table_reservation_list.length === 0
            ? [Config.env.app.manage_seating_options[3]]
            : Config.env.app.manage_seating_options
                .map((item) => {
                  if (res.data?.table_reservation_list.includes(item.value)) {
                    return item;
                  }
                })
                .filter((item) => item)
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  React.useEffect(() => {
    handleTableReservationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { t } = useTranslation();

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={{
          person: cartList?.tableReservation?.person
            ? cartList?.tableReservation?.person
            : persons.length > 0
            ? persons[0].value
            : "",
          seating_preference: cartList?.tableReservation?.seating_preference
            ? cartList?.tableReservation?.seating_preference
            : tablePreferenceList.length > 0
            ? tablePreferenceList[0].value
            : "",
        }}
        validationSchema={TableReservationMethodFormValidation}
        onSubmit={async (values) => {
          setIsLoading(true);
          const cachedCart = localStorage.getItem("cart");
          try {
            const body: any = {
              cart_id: cachedCart,
              person: values.person,
              seating_preference: values.seating_preference,
            };
            const res = await fetchData({
              url: "cart/table-reservation",
              method: "POST",
              body,
              token: authToken,
            });
            if (res.status_code === 200) {
              setIsLoading(false);
              handleCartList();
              handleAccordionClick("item-4");
            }
          } catch (error) {
            console.log("error", error);
          }
        }}
      >
        {({ errors, touched, setFieldValue, values, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <AccordionContent className="grid p-2 gap-2">
              <div className="grid gap-2">
                <div className="grid gap-2 w-full">
                  <Label className="text-left" htmlFor="date">
                    {t("cart.table_size.form.add_persons")}
                  </Label>
                  <div>
                    <DropDownList
                      id="person"
                      label={t("cart.table_size.form.persons")}
                      placeholder={t(
                        "cart.table_size.form.add_persons_placeholder"
                      )}
                      data={persons}
                      value={values.person}
                      defaultValue={
                        cartList?.tableReservation?.person ??
                        values.person ??
                        ""
                      }
                      onValueChange={(e: any) => {
                        setFieldValue("person", e, true);
                      }}
                      disabled={isLoading}
                    />

                    {errors.person && touched.person ? (
                      <FormError msg={t(errors.person as string)} />
                    ) : null}
                  </div>
                </div>
                <div className="grid gap-2 w-full">
                  <Label className="text-left" htmlFor="time">
                    {t("cart.seating_preference.title")}{" "}
                    <span className="text-red-500">*</span>
                  </Label>
                  <div>
                    <DropDownList
                      id="seating_preference"
                      label={t("cart.seating_preference.title")}
                      placeholder={t("cart.seating_preference.placeholder")}
                      data={tablePreferenceList}
                      value={values.seating_preference}
                      onValueChange={(e: any) => {
                        setFieldValue("seating_preference", e, true);
                      }}
                      disabled={isLoading || tablePreferenceList.length === 1}
                    />
                    {errors.seating_preference && touched.seating_preference ? (
                      <FormError msg={t(errors.seating_preference as string)} />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="flex justify-end w-full">
                <Button disabled={isLoading} type="submit">
                  {isLoading && (
                    <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                  )}
                  {t("save")}
                </Button>
              </div>
            </AccordionContent>
          </form>
        )}
      </Formik>
    </div>
  );
}
